import { z } from "zod";

const variantTypeSchema = z.enum(["primary", "secondary", "battery"]);

/**
 * Variant creation/update schema
 */
export const variantSchema = z.object({
  brand_id: z.number().int().positive(),
  name: z
    .string()
    .min(1, "Variant name must be at least 1 character")
    .max(50, "Variant name must be at most 50 characters")
    .regex(
      /^[a-zA-Z0-9äöüÄÖÜß\s\-_.,()\+\/!&'°×]+$/,
      "Variant name can only contain letters, numbers, spaces, hyphens, underscores, dots, commas, parentheses, plus, slash, exclamation marks, ampersand, apostrophe, degree symbol, and multiplication sign",
    )
    .transform((val) => val.trim()),
  variant_type: variantTypeSchema.default("secondary"), // Default to secondary (conservative)
});

export type VariantInput = z.infer<typeof variantSchema>;

/**
 * Variant approval schema (admin only)
 */
export const variantApprovalSchema = z.object({
  variant_id: z.number().int().positive(),
  is_approved: z.number().int().min(0).max(1),
});

export type VariantApprovalInput = z.infer<typeof variantApprovalSchema>;

/**
 * Variant global status toggle schema (admin only)
 */
export const variantGlobalStatusSchema = z.object({
  variant_id: z.number().int().positive(),
  is_globally_active: z.number().int().min(0).max(1),
});

export type VariantGlobalStatusInput = z.infer<
  typeof variantGlobalStatusSchema
>;

/**
 * Variant type update schema (admin only) - Phase 21
 */
export const variantTypeUpdateSchema = z.object({
  type: variantTypeSchema,
});

export type VariantTypeUpdateInput = z.infer<typeof variantTypeUpdateSchema>;

/**
 * Variant bulk type update schema (admin only) - Phase 21
 */
export const variantBulkTypeUpdateSchema = z.object({
  ids: z.array(z.number().int().positive()),
  type: variantTypeSchema,
});

export type VariantBulkTypeUpdateInput = z.infer<
  typeof variantBulkTypeUpdateSchema
>;
